<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-08-24 17:14:51
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-26 14:48:27
 * @FilePath: /goldenSalesMobile/src/views/SalerGroup/index.vue
 * @Description: 
-->
<template>
  <div class='page-container'>
    <nav-bar title="团队" />
    <div class="leader-info">
      <img class="avatar" src="../../assets/account_image/avatar.png" >
      <div>
        <p>{{ leaderInfo.name }}</p>
        <p>{{ leaderInfo.phone }}</p>
      </div>
      <span></span>
    </div>
    <ul class="group-info">
      <li v-for="(item, index) in groupInfos" :key="index">
        <span>{{ item.labelName }}</span>
        <span>{{ item.labelValue }}</span>
      </li>
    </ul>
    <g-block-title title="入团记录" />
    <van-list
      class="group-records"
      v-model="loading"
      :finished="finished"
      :error.sync="loadError"
      :immediate-check="false"
      :offset="30"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <li class="records-head">
        <span>手机号</span>
        <span>入团佣金</span>
        <span>入团时间</span>
        <span>订单量</span>
      </li>
      <li v-for="(item, index) in recordList" :key="index">
        <span>{{ item.DistributorPhone }}</span>
        <span>{{ item.Amount }}</span>
        <span>{{ item.CreateTime }}</span>
        <span>{{ item.OrderCount }}</span>
      </li>
    </van-list>
  </div>
</template>

<script>
import { getDistributorInfo, getDistributorMemberList } from '@/api/user'
export default {
  data() {
    return {
      leaderInfo: {
        name: '',
        phone: ''
      },
      groupInfos: [],
      loading: false,
      finished: false,
      loadError: false,
      pageIndex: 0,
      pageSize: 10,
      recordList: []
    }
  },

  created() {
    this.init()
  },

  methods: {
    // 初始化：获取分销员详情
    init() {
      getDistributorInfo()
        .then(res => {
          this.leaderInfo = {
            name: res.Name,
            phone: res.Phone
          }

          this.groupInfos = [
            {
              labelName: '团队人数',
              labelValue: res.MemberCount
            },
            {
              labelName: '累计收益',
              labelValue: res.TotalAmount
            },
            {
              labelName: '累计订单',
              labelValue: res.OrderCount
            },
            {
              labelName: '今日新增',
              labelValue: res.MemberCountForToday
            },
            {
              labelName: '今日收益',
              labelValue: res.AmountForToday
            },
            {
              labelName: '今日订单',
              labelValue: res.OrderCountForToday
            }
          ]

          this.getRecordList()
        })
    },

    getRecordList() {
      getDistributorMemberList(
        {
          pager: {
            pageindex: this.pageIndex,
            pagesize: this.pageSize
          }
        }
      )
        .then(res => {
          let data = res.Items
          if (data instanceof Array) {
            this.recordList = this.recordList.concat(data)
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true
            }
            // 加载结束
            this.loading = false
          }
        })
        .catch(err => {
// console.log(err)
          this.loadError = true
          this.loading = false
        })
    },

    // 上拉加载
    onLoad() {
// console.log('上拉加载')
      this.pageIndex++
      this.getRecordList()
    },
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
    
    .leader-info {
      @include flex-box(center, flex-start);
      width: 100%;

      >.avatar {
        flex: none;
        width: 188px;
        height: 188px;
        margin-left: 12px;
      }

      >div {
        flex: 1;
        >p:first-child {
          margin: 46px 0 10px 0;
          line-height: 56px;
          font-size: 40px;
          font-weight: 500;
          color: $secondFontColor;
        }

        >p:last-child {
          line-height: 40px;
          font-size: 28px;
          font-weight: 400;
          color: $baseFontColor;
        }
      }

      >span {
        margin-top: 48px;
        width: 188px;
        height: 154px;
        background: url('../../assets/common_image/xiaozhu.png') no-repeat center;
        background-size: 100%;
      }
    }

    .group-info {
      @include flex-box(space-between, center);
      @include border-box(0 32px);
      flex-wrap: wrap;
      width: 670px;
      height: 344px;
      margin: 0 auto;
      border-radius: 16px;
      box-shadow: 0px 0px 14px 0px rgba(182,182,182,0.5);

      >li {
        @include flex-box(flex-start, flex-start);
        flex-direction: column;
        flex: none;
        margin-right: 120px;
        font-weight: 500;

        &:nth-child(3n + 3) {
          margin-right: 0;
        } 

        >span:first-child {
          margin-bottom: 10px;
          line-height: 42px;
          font-size: 30px;
          color: $secondFontColor;
        }

        >span:last-child {
          line-height: 40px;
          font-size: 34px;
          color: #888888;
        }
      }
    }

    .group-records {
      width: 100%;

      >li {
        @include flex-box(center, center);
        width: 100%;
        min-height: 80px;

        &:first-child {
          line-height: 40px;
          font-size: 28px;
        }

        &:not(:first-child) {
          line-height: 34px;
          font-size: 24px;
        }

        &:nth-child(odd) {
          background: #F7F7F7;
        }

        >span {
          @include flex-box(center, center);
          flex: none;

          &:nth-child(1){
            width: 25%;
          }

          &:nth-child(3){
            width: 35%;
          }

          &:nth-child(2),
          &:nth-child(4) {
            width: 20%;
          }
        }
      }
    }
  }
</style>
